<template>
  <a :href="content.link" target="_blank" :title="content.name" class="partner">
    <Image :source="content.logo" />
  </a>
</template>

<script>
import { Image } from '@/components/global'

export default {
  name: 'PartnerCard',
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
  components: { Image },
}
</script>
